export default __webpack_public_path__ + "static/wstem1-ed48ae4050be9196c9453916eef07caf.jpeg";